import LinkButton from 'components/shared/button/LinkButton';
import GNEModal from 'components/shared/modal/Modal';
import { HELP_MODAL_LINK_FOR_UPDATE } from 'constants/constants';

function Help(props) {
  const title = (
    <div className='mb-2 d-flex'>
      {' '}
      <i className='icon icon__help_black'></i>
      <p className='mb-1 text text__bold text__base'>Help</p>
    </div>
  );
  const content = (
    <>
      <div className='text text__small px-2'>
        If you’re curious about how Views have evolved in C360, &nbsp;
        <a
          href={HELP_MODAL_LINK_FOR_UPDATE}
          target='_blank'
          rel='noreferrer'>
          <span className='text__bold text-decoration-underline'>
            here’s a brief update
          </span>
        </a>
        . Views are no longer confined to the “Insights” section*—they now
        extend to all sections (like Engagement, Affiliation, etc.) within an
        Insight board. You can create tiles specific to each view and save
        filter selections tied to that view.
        <br />
        <br />
        For example, you could create an Ophtha View with tiles and filters
        tailored to the Ophtha squad or product selection. This way, you can
        manage different perspectives within a single board without needing to
        create multiple boards for each use case.
        <br />
        <br />
        <p className='text text__small'>
          <span className='text__bold'>Note:</span> Creating a view is the first
          step in building a custom Insight board, allowing you to save your
          tiles and filters for easy access later.
        </p>
        <p className='text text__small'>
          <span className='text__bold'>Caveat:</span> The Insights section that
          lets you create tiles is currently not applicable to Payer or Parent
          Payer as customer types. However, this functionality is planned to be
          available soon with Payer-specific KPIs.
        </p>
      </div>

      <div className='d-flex justify-content-end'>
        <LinkButton
          onClick={props.onHide}
          className='text text__small'>
          Close
        </LinkButton>
      </div>
    </>
  );

  return (
    <GNEModal
      show={props.show}
      onHide={props.onHide}
      content={content}
      titlecontent={title}
      css={`size-new-lg animate__animated animate__${
        props.hide
          ? 'fadeOutTopRight'
          : props.show
            ? 'fadeInTopRight'
            : 'fadeOutTopRight'
      }`}
      backdrop='static'
    />
  );
}

export default Help;
